<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Campaign</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.campaigns.index')">
                                    Campaign
                                </Link>
                            </li>
                            <li class="breadcrumb-item active">{{ isEditing ? "Edit" : "Add" }} Campaign
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">

                <div class="card-body">
                    <form @submit.prevent="saveCampaign" enctype="multipart/form-data">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Campaign Title</label>
                                        <input type="text" v-model="campaign.title" class="form-control"
                                               placeholder="Campaign Title"
                                               required>
                                        <div v-if="campaign.errors.title" class="text-danger text-small">
                                            {{ campaign.errors.title }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" v-show="campaign.reoccurring">
                                    <div class="controls">
                                        <label>Campaign Start Date</label>
                                        <input type="date" v-model="campaign.start_date" class="form-control"
                                               placeholder="Campaign Start Date">
                                        <div v-if="campaign.errors.start_date" class="text-danger text-small">
                                            {{ campaign.errors.start_date }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Description</label>
                                        <textarea
                                            v-model="campaign.description"
                                            placeholder="Enter something..."
                                            rows="1"
                                            class="form-control"
                                            required
                                        ></textarea>
                                        <div v-if="campaign.errors.description" class="text-danger text-small">
                                            {{ campaign.errors.description }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" v-show="campaign.reoccurring">
                                    <div class="controls">
                                        <label>Campaign End Date</label>
                                        <input type="date" v-model="campaign.end_date" class="form-control"
                                               placeholder="Campaign End Date">
                                        <div v-if="campaign.errors.end_date" class="text-danger text-small">
                                            {{ campaign.errors.end_date }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="form-group">
<!--                                    <div class="controls">-->
<!--                                        <label class="form-label">Channels</label>-->
<!--                                        <select v-model="campaign.channels" id="" class="form-control" multiple required>-->
<!--                                            <option v-for="(value, key) in channels" :value="key" :key="key">{{ value }}</option>-->
<!--                                        </select>-->
<!--                                        <span v-if="campaign.errors.channels"-->
<!--                                              class="text-danger text-small">{{ campaign.errors.channels }}</span>-->
<!--                                    </div>-->
                                    <br>
                                    <div class="controls">
                                        <label class="form-label">Channels</label>
                                        <div class="btn-group">
                                            <button
                                                v-for="(value, key) in channels"
                                                :key="key"
                                                :class="campaign.channels.includes(key) ? 'btn btn-primary' : 'btn btn-outline-primary'"
                                                @click.prevent="toggleChannel(key)"
                                            >
                                                {{ value }}
                                            </button>
                                        </div>
                                        <span v-if="campaign.errors.channels" class="text-danger text-small">
                                            {{ campaign.errors.channels }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <template v-if="!isEditing">
                                <div class="col-12">
                                    <div class="form-group">
                                        <div class="controls">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="campaign.reoccurring"
                                                       id="defaultCheck1"
                                                       :true-value="true" :false-value="false">
                                                <label class="form-check-label" for="defaultCheck1">
                                                    Is this Campaign Reoccurring(if checked, the campaign will be
                                                    sent to users everyday for the duration specified)?
                                                </label>
                                            </div>
                                            <span v-if="campaign.errors.reoccurring"
                                                  class="text-danger text-small">{{
                                                    campaign.errors.reoccurring
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    {{ isEditing ? 'Update' : 'Save' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";

export default {
    metaInfo: {title: 'Create Campaign'},
    name: 'CampaignCreate',
    props: [
        'isEditing',
        'campaignData',
        'channels',
    ],
    components: {
        Link,
    },
    layout: Layout,
    data() {
        return {
            campaign: this.$inertia.form({
                start_date: null,
                end_date: null,
                title: null,
                description: null,
                reoccurring: false,
                channels: [],
            }),
            saving: false
        }
    },
    methods: {
        async saveCampaign() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => this.saving = false,
                onError: () => {
                    this.saving = false;
                }
            };

            this.isEditing ?
                this.campaign.put(route('admin.campaigns.update', this.campaignData.id), options)
                :
                this.campaign.post(route('admin.campaigns.store'), options);
        },
        toggleChannel(key) {
            const index = this.campaign.channels.indexOf(key);
            if (index > -1) {
                this.campaign.channels.splice(index, 1);
            } else {
                this.campaign.channels.push(key);
            }
        }
    },
    mounted() {
        if (this.isEditing) {
            this.campaign.start_date = this.campaignData.start_date;
            this.campaign.end_date = this.campaignData.end_date;
            this.campaign.title = this.campaignData.title;
            this.campaign.description = this.campaignData.description;
            this.campaign.channels = this.campaignData.channels;
            this.metaInfo.title = 'Update Campaign';
        }
    },
}
</script>
